export default __webpack_public_path__ + "static/media/DSC_0501.11c4884c.jpg";